import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'

export const usePremiumUnitsTranslation = () => {
  const [t] = useTranslation('web_ui')

  return useCallback(
    (unit: string) => {
      return t(`premiums.unit_options.${unit}`, `${unit}`)
    },
    [t]
  )
}
